import React from "react";
import styled from "styled-components";
import { Link } from "../Link";

const OverflowMenu = styled("div")`
  position: fixed;
  z-index: var(--z-popupmenu);
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  max-height: 80%;
`;

const ActionsContainer = styled("div")`
  overflow-y: auto;
`;

const OverflowBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--black);
  z-index: var(--z-popupmenu);
`;

const OverFlowItem = styled("div")`
  width: 100%;
  padding: 0 20px;
  cursor: pointer;
  font-size: 14px;
  line-height: 90px;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  ${({ icon }) => icon && `column-gap: 24px;padding-left:28px;`};
  ${({ icon }) =>
    icon ? "justify-content: left" : "justify-content:space-between"};
  color: var(--grey900);
  ${({ enabled }) =>
    enabled ? "" : `color: var(--grey200); pointer-events: none;`};
  border-bottom: 1px solid var(--grey150);
  background: white;
`;

export const PopupMenu = ({ onClose, actions, testId }) => {
  return (
    <>
      <OverflowBackground data-testid="backdrop" onClick={onClose} />

      <OverflowMenu data-testid={testId}>
        <ActionsContainer data-testid="ActionsContainer">
          {actions.map((action, i) => {
            if (!action || action.isHidden) return null;

            if (action.onClick && typeof action.onClick !== "function") {
              throw Error("'onClick' property must be of type function.");
            }

            if (action.to && typeof action.to !== "string") {
              throw Error("'to' property must be of type string.");
            }

            const key = action.enum || action.id || `popupMenuAction-${i}`; // Use a unique property or fallback to index

            return (
              <Link
                testId={"popMenuOption-" + i}
                key={key}
                onClick={
                  action.onClick && !action.isDisabled ? action.onClick : null
                }
                to={action.to && !action.isDisabled && action.to}
              >
                <OverFlowItem
                  enabled={!action.isDisabled}
                  {...action.props}
                  data-testid={action.enum}
                  icon={action.icon}
                >
                  {action.icon}
                  {typeof action.title == "function"
                    ? action.title()
                    : action.title}
                </OverFlowItem>
              </Link>
            );
          })}
        </ActionsContainer>
      </OverflowMenu>
    </>
  );
};
